export class DuplicateChemiseInfos {
  description: string;
}
